import { Component } from '@angular/core';

@Component({
  selector: 'app-store-icon',
  templateUrl: './store-icon.component.html',
  styleUrl: './store-icon.component.scss'
})
export class StoreIconComponent {

}
